export class NovoItemMaterialCaracteristica {
  codigoCaracteristica: string;
  codigoValorCaracteristica: string;
  siglaUnidadedeMedida: string;
  unidadeFornecimento: string;
}
